import { Form, Input, InputNumber, Select } from 'antd'
import React, { useMemo, useState } from 'react'
import { Horizontal, Texto } from '@gravitate-js/excalibrr'

export const ValueEditor = ({ property, setNumberValue, numberValue, numberInputProperties }) => {
  if (!property) return null
  const textInputProperties = ['name', 'carding_instructions']
  if (textInputProperties.includes(property)) {
    const maxLength = property === 'name' ? 60 : 300
    const placeholder = `Enter ${property === 'name' ? 'name' : 'instructions'}`
    return (
      <Form.Item
        name={'value'}
        label={'Value'}
        rules={[{ required: property === 'name', message: 'Name is required.' }]}
      >
        <Input showCount maxLength={maxLength} style={{ width: '200px' }} placeholder={placeholder} />
      </Form.Item>
    )
  }

  if (numberInputProperties.includes(property)) {
    const handleNumberChange = (e) => {
      const val = e.target.value
      const fixedValue = val ? val.replace(/[^0-9]/g, '') : ''
      setNumberValue(fixedValue)
    }
    return (
      <Input
        type={'number'}
        style={{ width: '200px' }}
        value={numberValue}
        placeholder={'Enter a number'}
        onChange={handleNumberChange}
        min={0}
      />
    )
  }

  let options = []
  if (property === 'activity') {
    options = [
      { value: 'Loading', label: 'Loading' },
      { value: 'Unloading', label: 'Unloading' },
    ]
  }

  if (property === 'certification_trigger') {
    options = [
      { value: 'Automatic - Activity Based', label: 'Automatic - Activity Based' },
      { value: 'Manual - Date Based', label: 'Manual - Date Based' },
      { value: 'Never Expires', label: 'Never Expires' },
    ]
  }
  if (property === 'dispatch_impact') {
    options = [
      {
        value: 'Alert',
        label: (
          <Horizontal style={{ backgroundColor: 'var(--theme-warning-dim)' }}>
            <Texto>Alert</Texto>
          </Horizontal>
        ),
        className: 'warning-dim-bg ',
      },
      {
        value: 'Alert Manual, Block Optimizer',
        label: (
          <Horizontal style={{ backgroundColor: 'var(--theme-warning-dim)' }}>
            <Texto>Alert Manual, Block Optimizer</Texto>
          </Horizontal>
        ),
        className: 'warning-dim-bg',
      },
      {
        value: 'Block Dispatch',
        label: (
          <Horizontal style={{ backgroundColor: 'var(--theme-error-dim)' }}>
            <Texto>Block Dispatch</Texto>
          </Horizontal>
        ),
        className: 'error-dim-bg',
      },
      {
        value: 'Informational (No Impact)',
        label: (
          <Horizontal style={{ backgroundColor: 'var(--theme-color-2-dim)' }} className={'full-height-width'}>
            <Texto>Informational (No Impact)</Texto>
          </Horizontal>
        ),
        className: 'theme-2-bg',
      },
    ]
  }
  return (
    <Form.Item name={'value'} label={'Value'} rules={[{ required: true, message: 'Value is required.' }]}>
      <Select options={options} style={{ width: '200px' }} placeholder={'Select an option'} />
    </Form.Item>
  )
}
